<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs v3-portlet">
	<div class="cards-holder devices-tab">
		<div class="card card1 mRight demo-overview">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div class="preRoll-creative-completion-stats-container">
				<div class="title">
					<h4>Social Demographic Overview</h4>
					<span *ngIf="hasData">
						<a
							href="javascript:void(0)"
							class="datatable_download_icon"
							(click)="downloadCSV($event)"
							target="_blank"
							*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
						>
							<i class="fa fa-download" aria-hidden="true"></i>
						</a>
					</span>
				</div>
				<div class="preRoll-creative-completion-stats-scroll-div" *ngIf="hasData && currentGraphData">
					<div class="preRoll-creative-completion-stats" *ngFor="let demograph of currentGraphData">
						<div class="social-creative-header-content text-font-bold add-color">{{ demograph.name | titlecase }}</div>
						<div class="social-demo-impressions par-title-font add-color">
							{{ demograph.totalImpressions | number }} Impressions
						</div>
						<div class="progressbar">
							<div
								class="primary-color-bg-right-gradient"
								[ngStyle]="getPercentage('totalImpressions', demograph.totalImpressions)"
							></div>
						</div>
						<div class="social-demo-clicks par-title-font add-color">{{ demograph.totalClicks | number }} Clicks</div>
						<div class="progressbar">
							<div
								class="secondary-color-bg-right-gradient"
								[ngStyle]="getPercentage('totalClicks', demograph.totalClicks)"
							></div>
						</div>
						<div class="social-demo-clicks par-title-font add-color">
							{{ demograph.totalEngagements | number }} Engagements
						</div>
						<div class="progressbar">
							<div
								class="tertiary-color-bg-right-gradient"
								[ngStyle]="getPercentage('totalEngagements', demograph.totalEngagements)"
							></div>
						</div>
					</div>
				</div>
				<div class="no-data-container" *ngIf="!hasData">
					<div class="map-no-data">No Data to Display</div>
				</div>
			</div>
		</div>
		<div class="card card3 mLeft" id="display-creative-v3-chart-container">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div *ngIf="!hasData">
				<img [src]="placeholderimage" class="no-creative-data" />
			</div>

			<div [hidden]="!hasData">
				<div class="c-portlet__header">
					<div class="o-stack__cell">
						<h5 class="creative-charts-header">Social Demographics Comparison</h5>
					</div>
				</div>
				<div class="performance-graph-area" #bubblechartcontainer>
					<div class="display-creative-v3-legend-area legend-area">
						<div class="legend1">
							<div
								class="legend_item"
								[ngClass]="{ legend_item_selected: legendItem.selected }"
								(click)="processSelectedLegendItem(legendItem)"
								*ngFor="let legendItem of legend"
							>
								{{ legendItem.displayName }}
							</div>
						</div>
					</div>
					<div class="bubblechartcontainer">
						<div
							class="display-creative-v3-area-chart"
							*ngFor="let chartData of currentGraphData; let index = index"
							id="display-creative_{{ index }}"
						>
							<div class="creative-bubble-chart-cntr">
								<div>
									<app-social-demograph
										[legendData]="legend"
										[selectedLegend]="selectedLegend"
										[graphData]="chartData"
										(legendSelected)="processSelectedLegendItem($event)"
										[legendDisabled]="true"
										(mouseOutChart)="chartHover($event)"
										(mouseOverChart)="chartHover($event)"
										[svgWidth]="svgWidth"
										[svgHeight]="svgHeight"
										[ticksRotation]="'0'"
										[chartType]="'areaspline'"
									></app-social-demograph>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
